import { Link } from "react-router-dom";
import { ArrowUpRight, UtensilsCrossed, Hotel, ShoppingCart, Truck, Check } from "lucide-react";
import PageHero from "@/components/PageHero";
import BrandMarquee from "@/components/BrandMarquee";
import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/lib/media";

const services = [
  {
    icon: UtensilsCrossed,
    t: "Ristoranti & Trattorie",
    d: "Materie prime d'eccellenza selezionate per chef e brigate. Consegne quotidiane per menù sempre freschi.",
    img: IMAGES.chef,
    points: ["Selezione premium giornaliera", "Prodotti di stagione", "Ordini flessibili last-minute"],
  },
  {
    icon: Hotel,
    t: "Hotel & Alberghi",
    d: "Forniture continue e affidabili per colazioni, buffet, banqueting ed eventi di ogni dimensione.",
    img: IMAGES.fruitPlate,
    points: ["Grandi volumi garantiti", "Buffet e colazioni", "Assortimento ampio"],
  },
  {
    icon: ShoppingCart,
    t: "Supermercati",
    d: "Reparto ortofrutta sempre rifornito, curato e presentabile per fidelizzare i tuoi clienti.",
    img: IMAGES.marketVeg,
    points: ["Rifornimento costante", "Prodotto sempre fresco", "Prezzi competitivi"],
  },
  {
    icon: Truck,
    t: "Logistica Dedicata",
    d: "Mezzi refrigerati e consegne programmate su misura per la tua attività, con puntualità garantita.",
    img: IMAGES.van,
    points: ["Mezzi refrigerati", "Consegne in 24h", "Piani su misura"],
  },
];

export default function Servizi() {
  return (
    <main data-testid="servizi-page">
      <PageHero
        eyebrow="Servizi"
        title="Forniture"
        italic="su misura."
        subtitle="Distribuiamo frutta e verdura fresca a chi fa della qualità un mestiere. Per ogni realtà, un servizio pensato apposta."
      />

      <section className="mx-auto max-w-[1400px] px-4 sm:px-8 pb-24 space-y-6">
        {services.map((s, i) => (
          <Reveal key={s.t} delay={0.05}>
            <div
              data-testid={`servizio-${i}`}
              className={`group grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden rounded-3xl border border-[#1A3322]/10 bg-[#EAE7E1]/50 ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <div className="relative h-[42vh] lg:h-auto min-h-[320px] overflow-hidden [direction:ltr]">
                <img src={s.img} alt={s.t} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
              </div>
              <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center [direction:ltr]">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1A3322] text-[#F4F2EE] transition-colors duration-300 group-hover:bg-[#C85A32]">
                  <s.icon className="h-6 w-6" />
                </div>
                <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#1A3322]">{s.t}</h2>
                <p className="mt-4 text-lg leading-relaxed text-[#4A5A4E] max-w-lg">{s.d}</p>
                <ul className="mt-7 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-[#1A3322]">
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#8A9A5B]/25">
                        <Check className="h-3.5 w-3.5 text-[#2E5037]" />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <BrandMarquee dark />

      <section className="mx-auto max-w-[1400px] px-4 sm:px-8 py-24 lg:py-32">
        <Reveal>
          <div className="rounded-[2.5rem] bg-[#1A3322] px-8 sm:px-16 py-20 text-center">
            <h2 className="font-serif-display text-5xl sm:text-7xl text-[#F4F2EE] tracking-tight">
              Non trovi il tuo <span className="italic font-light text-[#E8801F]">settore?</span>
            </h2>
            <p className="mt-6 text-[#F4F2EE]/75 text-lg max-w-xl mx-auto">
              Contattaci: costruiamo insieme la fornitura perfetta per la tua attività.
            </p>
            <Link to="/contatti" data-testid="servizi-cta" className="group mt-10 inline-flex items-center gap-2 rounded-full bg-[#F4F2EE] text-[#1A3322] px-8 py-4 text-sm uppercase tracking-widest hover:bg-[#E8801F] hover:text-[#F4F2EE] transition-colors duration-300">
              Parliamone <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
